import React from 'react';
import styled from 'styled-components';
import { Button } from 'core/ui/atoms';

const SubmitButton = styled((props) => <Button btn-primary btn-rounded type="submit" {...props} /> )`
`;

export default SubmitButton;
